module.exports = __webpack_public_path__ + "img/butchers.e20dbffc.png";